import { get, store} from "@/services/resources";

export const  state = {
    conventionStats:undefined,

};
export const mutations = {
    SET_CONVENTION_STATS(state,payload){
        state.conventionStats = {...payload}
    },


};
export const actions = {
    get({commit}){
        return new Promise((resolve,reject)=>{
            get("").then((response)=>{
                commit('SET_STAFF',response.data)
                resolve(response)
            }).catch((error)=>{
                reject(error)
            })
        })
    },

    getConventionStats(_, data){
        return new Promise((resolve,reject)=>{
            store("stats/conventions", data).then((response)=>{
                resolve(response)
            }).catch((error)=>{
                reject(error)
            })
        })
    },
    getStats(_, data){
        return new Promise((resolve,reject)=>{
            store(data.url, data).then((response)=>{
                resolve(response)
            }).catch((error)=>{
                reject(error)
            })
        })
    },

    getExpertStats(_, data){
        return new Promise((resolve,reject)=>{
            store("stats/experts", data).then((response)=>{
                resolve(response)
            }).catch((error)=>{
                reject(error)
            })
        })
    },

    getProtocoleStats(_, data){
        return new Promise((resolve,reject)=>{
            store("stats/protocole", data).then((response)=>{
                resolve(response)
            }).catch((error)=>{
                reject(error)
            })
        })
    },

    getPlanAffaireStats(_, data){
        return new Promise((resolve,reject)=>{
            store("stats/plan-affaire", data).then((response)=>{
                resolve(response)
            }).catch((error)=>{
                reject(error)
            })
        })
    },
};


